<div class="screen-container">
  <div *ngIf="!isSummary; else summaryBlock">
    <app-card
      [title]="'genericFileUpload.' + currentRoute + '.title' | translate"
      [subtitle]="important"
      [currentStep]="flowService.currentQuestionIndex"
      [steps]="flowService.questionsLength"
    >
      <div left-content>
        <ng-template [ngTemplateOutlet]="mainBlock"></ng-template>
        <div actions class="navigationButtons">
          <button
            (click)="handleNextButtonClick()"
            mat-flat-button
            color="primary"
          >
            {{ "genericFileUpload.nextButtonText" | translate }}
          </button>
          <button
            (click)="handleBackButtonClick()"
            mat-flat-button
            color="secondary"
          >
            {{ "genericFileUpload.backButtonText" | translate }}
          </button>
        </div>
      </div>
      <div right-content>
        <app-contact></app-contact>
      </div>
    </app-card>
  </div>

  <ng-template #summaryBlock>
    <div class="summary">
      <ng-template [ngTemplateOutlet]="mainBlock"></ng-template>
    </div>
  </ng-template>
</div>

<ng-template #mainBlock>
  <form [formGroup]="genericFileUploadForm">
    <div left-content class="content-container">
      <app-file-uploader
        [label]="'genericFileUpload.' + currentRoute + '.label'"
        [control]="genericFiles"
        [controlName]="'genericFiles'"
        [genericPrefix]="genericPrefix"
        [applicationId]="applicationId"
        [uploaderName]="assetName.OTHER"
        [isSummary]="isSummary"
        [uploadLabel]="'genericFileUpload.' + currentRoute + '.uploadLabel'"
        [uploadMoreLabel]="
          'genericFileUpload.' + currentRoute + '.uploadMoreLabel'
        "
      ></app-file-uploader>

      <app-infobox
        [title]="
          'genericFileUpload.' + currentRoute + '.infobox.title' | translate
        "
        [content]="
          'genericFileUpload.' + currentRoute + '.infobox.content' | translate
        "
      >
      </app-infobox>
    </div>
  </form>
</ng-template>
